import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=3ab1d114"
import script from "./declaration.vue?vue&type=script&lang=ts"
export * from "./declaration.vue?vue&type=script&lang=ts"
import style0 from "./declaration.vue?vue&type=style&index=0&id=3ab1d114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports